import { Outlet, useLocation } from "react-router";
import { useEffect } from "react";
import Navbar from "../core/common/header/Navbar"; // Import your custom Navbar
import BackToTop from "../core/common/backtotop/backToTop";
import Footer from "./HomePages/home-four/footer";

const Feature = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <div className="main-wrapper">
        <div
          className={
            location.pathname === "/index-3"
              ? "home-3"
              : location.pathname === "/index-4"
              ? "home-4"
              : location.pathname === "/index-6"
              ? "home-six"
              : ""
          }
        >
          {/* 🔁 Conditionally render Navbar only for index-4 */}
          <Navbar />

          <Outlet />

          <Footer />

          <BackToTop />
        </div>

        <div className="sidebar-overlay"></div>
      </div>
    </>
  );
};

export default Feature;
